// extracted by mini-css-extract-plugin
export default {"container-overflow":"gNqkn3","containerOverflow":"gNqkn3"};